import * as lastDayOfMonthReducer from '../../redux/modules/lastDayOfMonth';

const mapStateToProps = state => ({
  lastDayOfMonth: state.lastDayOfMonth && state.lastDayOfMonth.lastDayOfMonth
});

const mapDispatchToProps = {
  ...lastDayOfMonthReducer
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/last-day-of-month/index.js